/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// react
import { useContext, useEffect, useState } from "react"
import dayjs from "dayjs"
// Kairos Components
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import {
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsSearchingContext,
} from "../../../components/Context"

// Kairos Others
import CONSTANT from "../../../constant"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TZyutyuHaisyaListGetRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"

import { SearchResultContext } from "./BunkatuZyutyuHaisyaListContext"
import {
  パターンBindings,
  品名Bindings,
  積地Bindings,
  卸地Bindings,
  積卸日Bindings,
  荷主Bindings,
  車輌Bindings,
  乗務員売上Bindings,
  alignRightBindings,
} from "./BunkatuZyutyuHaisyaListConstant"

import { T受注配車入力GridItem } from "../ZyutyuHaisyaList/TZyutyuHaisyaList"
import Decimal from "decimal.js"

import { excelFormat } from "../../../ts/util/haisyaUtil"
import util from "../../../ts/util"
import { Link, useHistory, useLocation } from "react-router-dom"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import { Button } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons"
import { メニューコード } from "../../../constant/menuCode"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import { TBunkatuZyutyuHaisyaListGetRes } from "../../../service/order/bunkatuZyutyuhaisya/TBunkatuZyutyuHaisya"

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const BunkatuZyutyuhaisyaListGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
}> = (props) => {
  const history = useHistory()
  const location = useLocation()

  const 分割受注配車入力PathList = util.getMenuPath(
    メニューコード.受注配車.分割受注配車入力
  )

  //#region [context]
  // ロード表示
  const { state: isSearching, setState: setIsSearching } =
    useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)
  // const preSearchCondition = useContext(SearchConditionContext)

  // 画面遷移制御
  const [forceUpdate, setForceUpdate] = useState(false)
  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZyutyuHaisyaListGetRes | T受注配車入力GridItem>,
    pageSize: number
  ) => {
    const newData: T受注配車入力GridItem[] = data.map((d) => {
      return { ...d, row_id: Symbol(), isSelected: false }
    })

    return new wjCore.CollectionView<T受注配車入力GridItem>(newData, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        車輌最大積載量: (data: T受注配車入力GridItem) =>
          data.トレーラ車種最大積載量 ?? data.最大積載量,
        受注No: (data: T受注配車入力GridItem) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0
                ? `-${data.受注枝番}`
                : data.複写フラグ === 1
                ? "-??"
                : ""
            }`
            return text
          } else {
            return ""
          }
        },
        padding車番: (data: T受注配車入力GridItem) =>
          util.createPadding車番(data.車番),
        paddingトレーラ車番: (data: T受注配車入力GridItem) =>
          util.createPadding車番(data.トレーラ車番),
        支払合計: (data: T受注配車入力GridItem) => {
          const 支払運送料 = new Decimal(data.支払運送料 ?? 0)
          const 支払付帯料 = new Decimal(data.支払付帯料 ?? 0)
          const 支払高速料 = new Decimal(data.支払高速料 ?? 0)
          return 支払運送料.plus(支払付帯料).plus(支払高速料).toNumber()
        },
        請求合計: (data: T受注配車入力GridItem) => {
          const 請求運送料 = new Decimal(data.請求運送料 ?? 0)
          const 請求付帯料 = new Decimal(data.請求付帯料 ?? 0)
          const 請求高速料 = new Decimal(data.請求高速料 ?? 0)
          return 請求運送料.plus(請求付帯料).plus(請求高速料).toNumber()
        },
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // 行頭選択
    // new wjcSelector.Selector(grid, {
    //   itemChecked: () => {
    //     setSelectedRows([...grid.rows.filter((r) => r.isSelected)])
    //   },
    // })
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        const binding = c.binding as keyof T受注配車入力GridItem
        let setHeaderText = ""
        if (荷主Bindings.includes(binding)) {
          setHeaderText = "荷主"
        } else if (パターンBindings.includes(binding)) {
          setHeaderText = "パターンCD"
        } else if (積卸日Bindings.includes(binding)) {
          setHeaderText = "積卸日"
        } else if (積地Bindings.includes(binding)) {
          setHeaderText = "積地"
        } else if (卸地Bindings.includes(binding)) {
          setHeaderText = "卸地"
        } else if (品名Bindings.includes(binding)) {
          setHeaderText = "品名"
        } else if (車輌Bindings.includes(binding)) {
          setHeaderText = "運行車輌"
        } else if (乗務員売上Bindings.includes(binding)) {
          setHeaderText = "乗務員売上"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true

        // if (alignRightBindings.includes(binding)) {
        //   c.align = "right"
        // } else {
        //   c.align = "left"
        // }

        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
    columnHeaders.rows.forEach((row) => {
      row.height = 40
    })

    // ヘッダ以外のAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setTextAlign = ""
      if (panel.cellType !== wjcGrid.CellType.ColumnHeader) {
        if (
          alignRightBindings.includes(
            panel.columns[c].binding as keyof T受注配車入力GridItem
          )
        ) {
          if (r !== 0) {
            setTextAlign = "right"
          }
        }
      } else {
        if (r === 0) {
          setTextAlign = "left"
        }
        cell.style.textAlign = setTextAlign
      }
    }
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (searchResult == null) return
    const GridCollectionView = createCollectionView([...searchResult], pageSize)
    setGridData({ data: GridCollectionView })
    flexGrid?.refresh()
    setIsSearching(false)
  }, [searchResult])
  //#endregion
  return (
    <>
      <input
        type="check"
        style={{ display: "none" }}
        value={forceUpdate ? 0 : 1}
        onChange={(e) => {
          setForceUpdate(e.currentTarget.checked)
        }}></input>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        excelFormatItem={excelFormat}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 4,
          isReadOnly: true,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.Column,
        }}
        headerComponent={
          <span>
            <Link
              to={`${分割受注配車入力PathList[0]}`}
              onClick={(e) => {
                if (isSearching) {
                  e.preventDefault()
                  e.stopPropagation()
                }
                gridPageHelper.savePageConditionData(location.pathname)
              }}>
              <Button variant="primary" disabled={isSearching}>
                <FontAwesomeIcon icon={faPlusSquare} />
                分割受注配車入力
              </Button>
            </Link>
          </span>
        }>
        <wjrGrid.FlexGridColumn
          binding="受注No"
          align={"center"}
          width={90}
          allowSorting={false}
          isRequired={false}
          header="編集">
          <EmptyTextHeader></EmptyTextHeader>
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TBunkatuZyutyuHaisyaListGetRes>
            ) => {
              return (
                <Button
                  type="button"
                  tabIndex={-1}
                  className="btn btn-small btn-primary move-edit-page"
                  onClick={() => {
                    // 画面全体のスクロール位置の保存
                    gridPageHelper.savePageConditionData(location.pathname)

                    history.push(
                      分割受注配車入力PathList[1].replaceAll(
                        ":id",
                        context.item.分割受注配車ID.toString()
                      )
                    )
                  }}>
                  編集
                </Button>
              )
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注No"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No">
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.ColumnHeader}
            template={() => (
              <div style={{ height: "100%" }}>受注No</div>
            )}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>

        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={90}
          isRequired={false}
          header="荷主CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主名"
          width={200}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="表紙名"
          width={128}
          isRequired={false}
          header="表紙名"></wjrGrid.FlexGridColumn>

        {/* 積卸日 */}
        <wjrGrid.FlexGridColumn
          binding="積日"
          width={96}
          format={"d"}
          header="積日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.積日)
                dt = dayjs(context.item.積日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          width={96}
          format={"d"}
          header="卸日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<TZyutyuHaisyaListGetRes>
            ) => {
              let dt = ""
              if (context.item.卸日)
                dt = dayjs(context.item.卸日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>

        {/* 積卸地 */}
        <wjrGrid.FlexGridColumn
          width={80}
          binding="積地積卸先コード"
          header="積地CD"
          isRequired={false}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地社名"
          width={150}
          isRequired={false}
          header="積地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地都道府県"
          width={100}
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地市区町村"
          width={100}
          isRequired={false}
          header="市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          width={80}
          binding="卸地積卸先コード"
          header="卸地CD"
          isRequired={false}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地社名"
          width={150}
          isRequired={false}
          header="卸地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地都道府県"
          width={100}
          isRequired={false}
          header="都道府県"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地市区町村"
          width={100}
          isRequired={false}
          header="市区町村"></wjrGrid.FlexGridColumn>

        {/* 品名 */}
        <wjrGrid.FlexGridColumn
          width={80}
          binding="品コード"
          header="品CD"
          isRequired={false}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品名"
          width={150}
          isRequired={false}
          header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積載品数量"
          width={100}
          isRequired={false}
          dataType={wjCore.DataType.Number}
          format={"N3"}
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分名称1"
          width={64}
          isRequired={false}
          header="単位"></wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="輸送備考"
          width={150}
          isRequired={false}
          header="輸送備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="配車状態区分名称1"
          isRequired={false}
          header="配車状態"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注部所名"
          width={100}
          isReadOnly={true}
          header="受注部所"></wjrGrid.FlexGridColumn>

        {/* 車輌 */}
        <wjrGrid.FlexGridColumn
          binding="運行部所名"
          isRequired={false}
          header="運行部所"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払先コード"
          width={100}
          isRequired={false}
          header="傭車先CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="傭車会社名"
          width={150}
          isReadOnly={true}
          header="傭車会社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車番"
          sortMemberPath={"padding車番"}
          header="ヘッド車番"
          width={100}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車種区分名称1"
          width={130}
          isReadOnly={true}
          header="ヘッド車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車番"
          sortMemberPath={"paddingトレーラ車番"}
          isRequired={false}
          header="トレ車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車種区分名称1"
          width={130}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="トレーラ車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車輌最大積載量"
          width={100}
          cssClass="number-col"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          dataType={wjCore.DataType.Number}
          header="最大積載量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          header="運転者"
          isRequired={false}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗者名"
          header="同乗者"
          isRequired={false}></wjrGrid.FlexGridColumn>

        <wjrGrid.FlexGridColumn
          binding="同乗者場所区分名称1"
          isRequired={false}
          header="同乗場所"></wjrGrid.FlexGridColumn>

        {/* 運転手売上 */}
        <wjrGrid.FlexGridColumn
          binding="乗務員売上額"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="乗務員運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員付帯料"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="乗務員付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="付帯高速料"
          width={120}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="稼働手当車種掛率区分名称1"
          width={100}
          isRequired={false}
          header="稼働掛率"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="食事手当"
          width={100}
          isRequired={false}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="特別手当"
          width={100}
          isRequired={false}
          header="特別手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗者売上額"
          width={100}
          cssClass="number-col"
          isRequired={false}
          dataType={wjCore.DataType.Number}
          header="同乗者売上"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </>
  )
}
export default BunkatuZyutyuhaisyaListGrid
